"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _constants = require("@insided/shared/constants");

var _reactModal = _interopRequireDefault(require("../../components/reactModal"));

var _Button = _interopRequireDefault(require("../../control-components/ui-components/Button"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var Authorize = function Authorize(_ref) {
  var username = _ref.username,
      email = _ref.email,
      communityName = _ref.communityName,
      termsConditions = _ref.termsConditions,
      clientId = _ref.clientId,
      csrfToken = _ref.csrfToken;
  var zapierApp = 'Zapier';
  return (0, _preact.h)(_reactModal.default, {
    className: "authorization-modal",
    isOpen: true
  }, (0, _preact.h)("h3", {
    className: "authorization-modal_title"
  }, (0, _preact.h)("span", {
    className: "authorization-modal_client-app-name"
  }, " ", zapierApp, " "), " wants to access your ", communityName, ' ', "account"), (0, _preact.h)("div", {
    className: "authorization-modal_message"
  }, (0, _preact.h)("div", {
    className: "authorization-modal_logo"
  }, (0, _preact.h)("img", {
    width: 265,
    src: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.default)('basePath')).concat(_constants.PLATFORM_GS_LOGO_PATH))
  })), (0, _preact.h)("div", {
    className: "authorization-modal_user-data"
  }, (0, _preact.h)("h6", null, ' ', "This will allow ", (0, _preact.h)("span", {
    className: "authorization-modal_client-app-name"
  }, " ", zapierApp, " "), " to access:"), (0, _preact.h)("p", null, email), (0, _preact.h)("p", null, username)), (0, _preact.h)("div", {
    className: "authorization-modal_additional-information"
  }, (0, _preact.h)("h6", {
    style: {
      fontWeight: 'bold'
    }
  }, ' ', "Make sure you trust ", (0, _preact.h)("span", {
    className: "authorization-modal_client-app-name"
  }, " ", zapierApp, " ")), (0, _preact.h)("p", null, " Some more information on why you should make sure to trust ", zapierApp))), (0, _preact.h)("div", {
    className: "authorization-modal_buttons"
  }, (0, _preact.h)("form", {
    action: (0, _absoluteUrlRuntime.resolveUrl)("/oauth/accessCode"),
    method: "POST"
  }, (0, _preact.h)("input", {
    type: "hidden",
    name: "client_id",
    value: clientId
  }), (0, _preact.h)("input", {
    type: "hidden",
    name: "yip_csrf_token",
    value: csrfToken
  }), (0, _preact.h)(_Button.default, {
    primary: true,
    type: "submit",
    loading: false,
    disabled: false,
    style: {
      width: '150px'
    },
    title: "Authorize"
  }), (0, _preact.h)(_Button.default, {
    secondary: true,
    loading: false,
    disabled: false,
    onClick: function onClick() {
      return window.history.go(-1);
    },
    style: {
      marginLeft: '10px',
      width: '150px'
    },
    title: "Cancel"
  }))), (0, _preact.h)("div", {
    className: "authorization-modal_privacy-terms"
  }, (0, _preact.h)("a", {
    className: "authorization-modal-terms-link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(termsConditions),
    rel: "noreferrer",
    target: "_blank"
  }, ' ', communityName, " privacy policy")));
};

var _default = Authorize;
exports.default = _default;